// extracted by mini-css-extract-plugin
export var childrenContainer = "_66-0";
export var virtualScrollArea = "_66-1";